export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10813.526e5148.jpg";